import { Instagram, ArrowUpRight } from "lucide-react";
import { GOOGLE_FORM_URL } from "@/lib/constants";

export const Footer = ({ onApply }) => {
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] pt-24 md:pt-32 pb-10">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center">
          <button
            onClick={onApply}
            data-testid="footer-cta"
            className="font-heading font-black uppercase tracking-tighter text-6xl sm:text-7xl lg:text-8xl leading-none text-white hover:text-[#E63946] transition-colors"
          >
            Let's Work.
          </button>
          <p className="mt-6 text-neutral-400 max-w-md mx-auto">
            Ready to break your plateau? Apply for 1-on-1 online coaching with
            Amani Lubembe.
          </p>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-6">
          <span className="font-heading text-xl font-black uppercase tracking-tight">
            AMANI<span className="text-[#E63946]">.</span>LUBEMBE
          </span>

          <div className="flex items-center gap-6">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="flex items-center gap-2 text-sm uppercase tracking-widest text-neutral-400 hover:text-white transition-colors"
            >
              <Instagram size={16} /> Instagram
            </a>
            <a
              href={GOOGLE_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-form-link"
              className="flex items-center gap-1 text-sm uppercase tracking-widest text-neutral-400 hover:text-white transition-colors"
            >
              Intake Form <ArrowUpRight size={14} />
            </a>
          </div>

          <span className="text-xs text-neutral-600 uppercase tracking-widest">
            © {new Date().getFullYear()} Amani Lubembe
          </span>
        </div>
      </div>
    </footer>
  );
};
